import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background-color: rgba(25, 0, 50, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: ${props => props.padding || '30px'};
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  z-index: 1;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg, 
      rgba(255, 64, 192, 0.08) 0%, 
      rgba(0, 0, 0, 0) 60%
    );
    z-index: -1;
    pointer-events: none;
  }
  
  &::after {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.05) 0%,
      rgba(255, 255, 255, 0) 80%
    );
    opacity: 0;
    z-index: -1;
    transition: opacity 0.6s ease;
    pointer-events: none;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 
      0 15px 35px rgba(0, 0, 0, 0.5),
      0 0 20px rgba(255, 64, 192, 0.2);
    border-color: rgba(255, 64, 192, 0.2);
    
    &::after {
      opacity: 1;
    }
  }
`;

const CardGlow = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(
    circle,
    rgba(255, 64, 192, 0.12) 0%,
    rgba(255, 64, 192, 0) 70%
  );
  border-radius: 50%;
  filter: blur(20px);
  opacity: 0.5;
  pointer-events: none;
  
  &.top-right {
    top: -75px;
    right: -75px;
  }
  
  &.bottom-left {
    bottom: -75px;
    left: -75px;
    background: radial-gradient(
      circle,
      rgba(255, 208, 0, 0.08) 0%,
      rgba(255, 208, 0, 0) 70%
    );
  }
`;

const Card = ({ children, className, ...props }) => {
  return (
    <CardContainer className={className} {...props}>
      <CardGlow className="top-right" />
      <CardGlow className="bottom-left" />
      {children}
    </CardContainer>
  );
};

export default Card; 